import moment from "moment";

export const dateFormats = {
  isoLocalDateTime: "yyyy-MM-dd'T'HH:mm:ss",
  fullDateShortTime: "YYYY-MM-DD HH:mm",
  fullDateLongTime: "YYYY-MM-DD HH:mm:ss",
  date: "DD/MM/YYYY",
  timeShortPoint: "HH.mm",
  timeShortPointFullHours: "kk.mm",
  timeShort: "HH:mm",
  hours: "HH",
};

class DateService {
  private lib: typeof moment;

  constructor(lib: typeof moment) {
    this.lib = lib;
  }

  public format(date: Date | string, format: string): string {
    return this.lib(date).format(format);
  }

  public convertToUTC(date: Date | string) {
    return this.lib.utc(date);
  }

  public isToday(date: Date | string) {
    return this.lib(date).isSame(new Date(), "d");
  }

  public isTomorrow(date: Date | string) {
    return this.lib(new Date()).add(1, "days").isSame(new Date(date), "d");
  }

  public isYesterday(date: Date | string) {
    return this.lib(new Date()).subtract(1, "days").isSame(new Date(date), "d");
  }

  public isBeforeNow(date: Date | string) {
    return this.lib(date).isBefore(new Date());
  }

  public getStartOfToday() {
    return moment(new Date()).startOf("day").toDate();
  }
}

export default new DateService(moment);
